import { EnvironmentProviders, makeEnvironmentProviders, Type } from '@angular/core';

import {
  provideTellentToolResultRenderer,
  ToolResultRenderer,
} from '@core/tellent-assistant-contracts';

import { RequestTicket, requestTicketSchema } from './request-ticket.schema';
import { TellentAssistantTicketCardComponent } from './tellent-assistant-ticket-card.component';

export function provideTellentTicketCardRenderer(): EnvironmentProviders {
  const renderer: ToolResultRenderer<RequestTicket> = {
    toolName: 'formatRequestTicket',
    schema: requestTicketSchema,
    component: <Type<{ payload: RequestTicket }>>(<unknown>TellentAssistantTicketCardComponent),
  };
  return makeEnvironmentProviders([provideTellentToolResultRenderer({ useValue: renderer })]);
}
